export type NumberValue = number | null;
export type InternalNumberValue = string | '' | undefined;

export const validateNumberValue = (value: unknown): value is NumberValue =>
	value === null || typeof value === 'number';

export const transformNumberToInternalValue = (publicValue: NumberValue): InternalNumberValue =>
	publicValue === null ? '' : String(publicValue);

export const transformNumberToPublicValue = (internalValue: InternalNumberValue): NumberValue =>
	[undefined, ''].includes(internalValue) ? null : Number(internalValue);
